import { __decorate, __metadata } from "tslib";
import { CreateDocumentRequest } from '@cbbt/itf-unverified-individual-customer-domain';
import { Field } from '@cbbt/lib-interface';
import { IdvBrands } from '../enum/IdvBrands.js';
export class AdditionalDocumentRequest extends CreateDocumentRequest {
    applicationId;
    brand;
    jwt;
}
__decorate([
    Field.string({
        description: 'Application Id',
        required: true,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], AdditionalDocumentRequest.prototype, "applicationId", void 0);
__decorate([
    Field.enum({
        enum: IdvBrands,
        required: true,
        description: 'Brand Name',
    }),
    __metadata("design:type", String)
], AdditionalDocumentRequest.prototype, "brand", void 0);
__decorate([
    Field.string({
        description: 'JWT',
        required: true,
        minLength: 1,
        log: false,
    }),
    __metadata("design:type", String)
], AdditionalDocumentRequest.prototype, "jwt", void 0);
//# sourceMappingURL=AdditionalDocumentRequest.js.map